var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46875 6.1527C2.05313 6.1527 2.61357 6.38484 3.02678 6.79805C3.44 7.21127 3.67214 7.77171 3.67214 8.35609C3.67214 8.94046 3.44 9.5009 3.02678 9.91412C2.61357 10.3273 2.05313 10.5595 1.46875 10.5595V12.0284C1.46875 12.418 1.62351 12.7916 1.89899 13.0671C2.17447 13.3426 2.54809 13.4973 2.93768 13.4973H14.6891C15.0787 13.4973 15.4523 13.3426 15.7278 13.0671C16.0033 12.7916 16.158 12.418 16.158 12.0284V10.5595C15.5736 10.5595 15.0132 10.3273 14.6 9.91412C14.1868 9.5009 13.9546 8.94046 13.9546 8.35609C13.9546 7.77171 14.1868 7.21127 14.6 6.79805C15.0132 6.38484 15.5736 6.1527 16.158 6.1527V4.68377C16.158 4.29419 16.0033 3.92056 15.7278 3.64508C15.4523 3.36961 15.0787 3.21484 14.6891 3.21484H2.93768C2.54809 3.21484 2.17447 3.36961 1.89899 3.64508C1.62351 3.92056 1.46875 4.29419 1.46875 4.68377V6.1527Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54785 3.21484V4.68377",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54785 12.0283V13.4972",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54785 7.62158V9.09051",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6271,
    height: 17.6271,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon 2.937ca6a775b62889f26d6ce03e4e5f82.svg";
export { ForwardRef as ReactComponent };